import request from '@/utils/request'
// 店铺列表
export function storeList(data) {
  return request({
    url: '/sys/store/list',
    method: 'post',
    data
  })
}
// 店铺删除
export function storeDelete(data) {
  return request({
    url: '/sys/store/delete',
    method: 'post',
    data
  })
}

// 店铺新增
export function storeAdd(data) {
  return request({
    url: '/sys/store/save',
    method: 'post',
    data
  })
}

